$(document).ready(function () {

  $(".qty-btn").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    let input = $(this).siblings(".qty-input");
    let value = parseInt(input.val());

    if ($(this).hasClass("plus")) {
      value++;
    }

    if ($(this).hasClass("minus")) {
      if (value > 1) value--;
    }

    input.val(value);
    $(".cart-qty-input").val(value);


  });




$(document).on('click', '#custom-buy-now', function (e) {
    
        e.preventDefault();
    e.stopPropagation();
    setTimeout(function(){
 $('.tpo-buy-it-now-btn').click();
 },500);
});



$(document).on('click', '.acc-header', function () {
    let item = $(this).closest('.acc-item');
    let content = item.find('.acc-content');

    // toggle content
    content.stop(true, true).slideToggle(300);

    // toggle active class
    item.toggleClass('active');
});





});



$(document).ready(function () {
  const el = document.getElementById('textfieldapp');
  if (el) {
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('margin', '0', 'important');
  }
});

$(document).ready(function () {
  const $textarea = $('textarea[data-name="properties[Engraving]"]');

  if ($textarea.length) {
    // Apply styles to textarea
    $textarea.css({
      'width': '100% !important',
      'max-width': '100% !important'
    });

    // Apply styles to its previous div
    $textarea.closest('div').prev('div').css({
      'width': '100% !important',
      'max-width': '100% !important'
    });
  }
});

$(document).ready(function () {

  function cleanComparePrice() {
    var el = $('#ComparePrice');
    if (el.length) {
      el.text(el.text().replace(/Compare at\s*/i, ''));
    }
  }

  // Run on page load
      setTimeout(function () {
  cleanComparePrice();
  }, 1000);
  // Run on variant click
  $(document).on('click', '.product-variant-option label', function () {
    setTimeout(function () {
      cleanComparePrice();
    }, 1000);
  });

});


